import React from 'react';
import { Dropdown, IDropdownOption, IDropdownStyles, TextField } from '@fluentui/react';
import { Rate } from '../services/ApiService';

interface RateSelectorProps {
    rateType: 'day' | 'night' | '';
    selectedRate: Rate | null;
    onRateChange: (rateType: 'day' | 'night' | '') => void;
    showRateDisplay?: boolean;
    dropdownStyles?: Partial<IDropdownStyles>;
}

const RateSelector: React.FC<RateSelectorProps> = ({
    rateType,
    selectedRate,
    onRateChange,
    showRateDisplay = false,
    dropdownStyles,
}) => {
    const rateOptions: IDropdownOption[] = [
        { key: 'day', text: 'Den' },
        { key: 'night', text: 'Noc' },
    ];

    const handleChange = (_: React.FormEvent<HTMLDivElement>, option?: IDropdownOption) => {
        if (!option) {
            onRateChange('');
            return;
        }
        onRateChange(option.key as 'day' | 'night');
    };

    const resolvedRate = rateType === 'night'
        ? (selectedRate?.nightRate ?? 0)
        : rateType === 'day'
            ? (selectedRate?.dayRate ?? 0)
            : 0;

    return (
        <>
            <Dropdown
                placeholder="Sazba"
                label="Sazba"
                selectedKey={rateType || null}
                options={rateOptions}
                styles={dropdownStyles}
                required
                onChange={handleChange}
            />

            {showRateDisplay && rateType && (
                <TextField
                    label="Sazba na kilometr"
                    value={resolvedRate.toString()}
                    type="number"
                    disabled
                    suffix="kč/km"
                />
            )}
        </>
    );
};

export default RateSelector;
